<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1> Governing body</h1>
                </div>
            </div>
        </div>
    </div>
</section>      

<section class="section-lg std-scholarship">
    <div class="container">

            <div class="col-md-12">
                
                <div class="table-responsive"> 
                    <table class="table table-bordered text-center tbl_custom">
                        <thead>
                            <tr>
                                <th colspan="3">Governing Body (2022-23)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>Chairman</td>
                                <td>"Hon'ble Shri Sunil G. Raisoni</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Managment Nominee</td>
                                <td>Mr Shreyas Raisoni</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Managment Nominee</td>
                                <td>Dr. Aarti Deshpande</td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>Managment Nominee</td>
                                <td>Mr. Ashwin Pande</td>
                            </tr>
                            <!-- <tr>
                                <td>5</td>
                                <td>Principal Nominee</td>
                                <td>Ms. Kanchan Tiwari</td>
                            </tr> -->
                        <tr>
                            <td>5</td>
                            <td>Principal Nominee</td>
                            <td>Dr Manish Shah</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>Educationist</td>
                            <td>Dr Rachna Jawa (SRCC)</td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td> Industrialist</td>
                            <td>Mr. Ramakrishnan (Exhino Capital)</td>
                        </tr>
                        <tr>
                            <td>8</td>
                            <td>UGC Nominee</td>
                            <td>Awaited</td>
                        </tr>
                        <tr>
                            <td>9</td>
                            <td>University Nominee</td>
                            <td>Awaited</td>
                        </tr>
                        <tr>
                            <td>10</td>
                            <td>State Govt Nominee</td>
                            <td>Awaited</td>
                        </tr>
                        <tr>
                            <td>11</td>
                            <td>Ex Officio (Principal)</td>
                            <td>Dr Jasvinder Kaur</td>
                        </tr>
                    </tbody>
                </table>
                </div>
            </div>
    </div>
</section>

<section class="section-lg std-scholarship">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="inner-title"  >
                <h4>Scan Minutes GHRCCST</h4>
                
                </div>
                <div class="col-md-4 col-lg-3">
                    <div class="pdf-box">
                        <div class="pdf-icon">
                            <span><i class="fa fa-file-pdf-o"></i></span>
                        </div>
                        <h5>Scan Minutes GHRCCST</h5>
                        <a class="button-text" href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/mom.pdf"
                            target="_blank">Read More</a>
                    </div>
                </div>
                <!-- <div class="col-md-4 col-lg-3">
            <div class="pdf-box">
                <div class="pdf-icon">
                    <span><i class="fa fa-file-pdf-o"></i></span>
                </div>
                <h5 class="">Scan Minutes GHRCCST</h5>            
                <a class="button-text" href="https://drive.google.com/file/d/1TZTMpmj6tq0kgCn1tXAQEK8CyplKQhpw/view?usp=sharing" target="_blank">Read More</a>
            </div>
            </div> -->

            </div>
        </div>
    </div>
</section>